export default {
    NESTE_MUNICIPIO: 1,
    OUTRO_MUNICIPIO: 2,
    OUTRO_PAIS: 3,
}